export default __webpack_public_path__ + "static/media/nodeJsLogo.adf3246d.svg";